import React from 'react';
import { useAds } from 'hooks/use-ads';

const AdConfig: React.FC = () => {
    const config = useAds();

    if (!config?.enabled) {
        return null;
    }

    return (
        <>
            <script dangerouslySetInnerHTML={{ __html: `var dlApi = (${JSON.stringify(config)})` }} />
            <script src="//lib.onet.pl/s.csr/build/dlApi/dl.boot.min.js" async={true} />
        </>
    );
};

export default AdConfig;
